import { AnimatePresence, m } from 'motion/react'
import { useEffect, useState } from 'react'

// Plays on every fresh load of the site (not on client-side route changes,
// since Layout -- and this component with it -- stays mounted across those;
// only an actual reload remounts it) -- a plain wordmark wipe, no spinner,
// no orb, no loading bar. Skipped entirely for reduced-motion visitors
// rather than shown instantly, since it carries no information they'd miss.
function shouldShowIntro() {
  if (typeof window === 'undefined') return false
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function IntroLoader() {
  const [visible, setVisible] = useState(shouldShowIntro)

  useEffect(() => {
    if (!visible) return
    const timer = setTimeout(() => setVisible(false), 1100)
    return () => clearTimeout(timer)
  }, [visible])

  useEffect(() => {
    if (!visible) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [visible])

  return (
    <AnimatePresence>
      {visible && (
        <m.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-canvas"
        >
          <m.span
            initial={{ clipPath: 'inset(0 100% 0 0)' }}
            animate={{ clipPath: 'inset(0 0% 0 0)' }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-[clamp(28px,6vw,44px)] italic tracking-[-0.01em] text-ink"
          >
            Flowscale
          </m.span>
        </m.div>
      )}
    </AnimatePresence>
  )
}
